import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";

// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';


import {
   parentViewAgreement,
   fetchStudentAgreement,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import ViewElement from '../students/component/agreement/viewagreement';

class viewAgreementParent extends Component {

   constructor(props) {

      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         viewdiv: true,
         editdiv:false,
         vfm:2,
         cstid:'',

      };


      this.onBackSection = this.onBackSection.bind(this);
      
   }

   UNSAFE_componentWillMount() {
      this.props.parentViewAgreement();
   }

 
   
   onBackSection() {
      this.setState({
         viewdiv: true,
         editdiv: false,

      });
   }

   onBackDashboard(){
      window.location.replace('/app/parentdashboard');
   }


   viewSession(id){
    
        this.props.fetchStudentAgreement(id).then((data) => {   
            this.setState({
                cstid:id,
                viewdiv: false,
                editdiv: true,

            });
        });   
   }

   

   render() {
      const { match, allparentagreement, loading } = this.props;
      const usrid=localStorage.getItem('user_id'); 
      const options = {
         filterType: 'dropdown',
         rowsPerPage: 50,
         responsive:'standard',
         rowsPerPageOptions: [50, 100, 150],
         selectableRowsHideCheckboxes: true,
      };

      const columns = [
         { name: "no", label: "NO" },
         { name: "type", label: "Agreement Type" },
         { name: "excdate", label: "Execution Date" },
         { name: "startdate", label: "Agreement Start Date" },
         { name: "enddate", label: "Agreement End Date" },
         { name: "action", label: "View" },
         { name: "action1", label: "Download" },
      ];

      const tabledata = allparentagreement.map((assmntval, idx) => {
         const ebtn = (<button class="mr-10 mb-10 btn btn-info btn-sm" onClick={() => this.viewSession(assmntval.ctsaID)}>View</button>);
         if(assmntval.ctsa_acceptedBy==0){
             var dbtn="";
         }else{
            var dbtn = (
                <a href={AppConfig.apiurl+'/ctagreementdownload?id='+assmntval.ctsaID+'&usrid='+usrid}><button class="mr-10 mb-10 btn btn-warning btn-sm">Download</button></a>
            );
         }

         return {
            no: idx + 1,
            type: assmntval.name,
            excdate: assmntval.exdate,
            startdate: assmntval.stdate,
            enddate: assmntval.eddate,
            action: ebtn,
            action1: dbtn,
         };
      });
      return (
         <div className="saas-dashboard">
            <Helmet>
               <title> View Agreement | {AppConfig.appTitle}</title>
               <meta name="description" content="Golf" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.viewagreement" />} match={match} />

            {this.state.viewdiv &&
               <div className="col-sm-12 col-lg-12">
                  <RctCollapsibleCard heading="List" backtoadd fullBlock onClick={this.onBackDashboard}>
                     <MUIDataTable
                        data={tabledata}
                        columns={columns}
                        options={options}
                     />
                  </RctCollapsibleCard>
               </div>
            }

                {this.state.editdiv &&
                    <ViewElement onClick={this.onBackSection} data={this.state} />
                }
            

         </div>
      )
   }
}

const mapStateToProps = ({ contractstudent }) => {
   const { allparentagreement, loading } = contractstudent;
   return { allparentagreement, loading };
}

export default connect(mapStateToProps, {
   parentViewAgreement,
   fetchStudentAgreement,
})(viewAgreementParent); 